export * from './ProductCardV2Label';
